// TODO: This code is shit, find a better way to format messages from the API
export const formatAPIErrorMessages = (messages) => {
  if (Array.isArray(messages)) {
    return messages.map(message => {
      return capitalizeFirstLetter(message)
    }).join(", ");
  }
  return messages;
}

const capitalizeFirstLetter = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 * getToken
 * @param {string} key: string
 */

export const getToken = (key) => {
  return JSON.parse(localStorage.getItem(key)) ?? null
}

/**
 * 
 * @param {string} key 
 * @param {any} value 
 * @returns {void}
 */

export const saveToken = (key, value) => localStorage.setItem(key, JSON.stringify(value))